import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { LicenseService } from 'app/core/services/license.service';

@Component({
  selector: 'app-google-slides',
  templateUrl: './google-slides.component.html',
  styleUrls: ['./google-slides.component.css']
})
export class EvaluationGoogleSlidesComponent extends LoadingPage {

  deliverable;
  url: SafeResourceUrl;

  constructor(private route: ActivatedRoute,
              private licenseService: LicenseService,
              private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {

    const deliverableId = this.route.snapshot.params['deliverableId'];
    this.loading();
    this.licenseService.getEvaluationPresentationUrl(deliverableId)
      .bindToLifecycle(this)
      .subscribe(body => {
        this.deliverable = body;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(body.data);
        this.ready();
      }, err => this.error());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/google-slides/google-slides.component.ts